export interface ItemType {
  id: string;
  name: string;
  giftTypes?: string[];
}

export const EVENT_GOODS_ITEM_TYPES: ItemType[] = [
  { id: 'ALL', name: '전체', giftTypes: [] },
  { id: 'PHOTO', name: '포토', giftTypes: [] },
  { id: 'STORAGE', name: '보관', giftTypes: [] },
  { id: 'ACCESSORY', name: '잡화', giftTypes: [] },
  { id: 'DECORATION', name: '꾸미기', giftTypes: [] },
  { id: 'EVENT', name: '이벤트', giftTypes: [] }
];

/**
 * 카테고리 ID를 API 요청용으로 변환
 * @param category - 카테고리 ID
 * @returns API 요청용 카테고리 ID
 */
export const getApiCategory = (category: string): string => {
  if (category === 'all') return 'ALL';
  return category.toUpperCase();
};

/**
 * 선택된 카테고리에 따라 굿즈를 필터링 (모든 굿즈 표시)
 * @param goods - 굿즈 배열
 * @param category - 선택된 카테고리
 * @returns 필터링된 굿즈 배열
 */
export const filterGoodsByCategory = (goods: any[] | undefined, category: string): any[] => {
  if (!goods) return [];
  if (category === 'ALL' || category === 'all') {
    return goods;
  }
  return goods.filter((g) => g.category === category);
};

/**
 * 선택된 아이템들만 필터링
 * @param goods - 굿즈 배열
 * @param selectedItems - 선택된 아이템들
 * @returns 필터링된 굿즈 배열
 */
export const filterGoodsBySelectedItems = (
  goods: any[] | undefined,
  selectedItems: string[]
): any[] => {
  if (!goods) return [];
  return goods.filter((g) => selectedItems.includes(g.key));
};
